const filenameSegmenter =
  typeof Intl !== "undefined" && typeof Intl.Segmenter === "function"
    ? new Intl.Segmenter("zh-CN", { granularity: "grapheme" })
    : null;

function splitGraphemes(input: string): string[] {
  if (filenameSegmenter) {
    return Array.from(filenameSegmenter.segment(input), (item) => item.segment);
  }

  return Array.from(input);
}

function formatTimestamp(date: Date): string {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}${month}${day}-${hours}${minutes}`;
}

function sanitizeFilenameText(text: string, fallback: string): string {
  const normalized = text.normalize("NFC").trim().replace(/\s+/g, " ");
  const allowed = splitGraphemes(normalized).filter((segment) =>
    /[\p{Letter}\p{Number}]/u.test(segment),
  );

  const safeText = allowed.slice(0, 12).join("");
  return safeText || fallback;
}

export function buildExportFilename(
  text: string,
  extension: "mp3" | "srt" | "lrc",
  now = new Date(),
  fallback = "配音",
): string {
  const prefix = sanitizeFilenameText(text, fallback);
  return `${prefix}_${formatTimestamp(now)}.${extension}`;
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
